/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_OfflineInputs */

const en_us2_board_offline = /** @type {(inputs: Board_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see the board.`)
};

const pt_br2_board_offline = /** @type {(inputs: Board_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver o mural.`)
};

const pt_pt2_board_offline = /** @type {(inputs: Board_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver o mural.`)
};

/** @type {(inputs: Board_OfflineInputs) => LocalizedString} */
const es_419_board_offline = en_us2_board_offline;

/** @type {(inputs: Board_OfflineInputs) => LocalizedString} */
const fr_fr2_board_offline = en_us2_board_offline;

/** @type {(inputs: Board_OfflineInputs) => LocalizedString} */
const de_de2_board_offline = en_us2_board_offline;

/** @type {(inputs: Board_OfflineInputs) => LocalizedString} */
const it_it2_board_offline = en_us2_board_offline;

/**
* | output |
* | --- |
* | "Connect to the internet to see the board." |
*
* @param {Board_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_offline = /** @type {((inputs?: Board_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_offline(inputs)
	if (locale === "es-419") return es_419_board_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_board_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_board_offline(inputs)
	if (locale === "de-DE") return de_de2_board_offline(inputs)
	if (locale === "it-IT") return it_it2_board_offline(inputs)
	return en_us2_board_offline(inputs)
});
export { board_offline as "board.offline" }